export default "__VITE_ASSET__Be64e8st__"